import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    paddingVertical: 0,
    paddingHorizontal: spacing.m,
    flex: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.s,
    paddingVertical: spacing.s,
  },
  chainRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
  },
  balanceContainer: {
    gap: spacing.xxs,
    alignItems: 'flex-end',
  },
  dividerWrapper: {
    marginHorizontal: -spacing.m,
  },
  divider: {
    opacity: 0.1,
  },
  actionsContainer: {
    paddingVertical: spacing.xs * 1.5,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
